import "../style/buttons.scss";
import { setSVGColor } from "../SVGHelper";
import React from "react";
import { ReactSVG } from "react-svg";

/**
 * Styles an svg based button with the colors/states of a normal Button but with less nesting and the icon takes up full area.
 *
 * @see Button - for more details on how to customize the button properties.
 * @see buttons.scss - for more details on the available button classes.
 *
 * @param {object} props - React props object
 * @param {string} props.src - SVG path data for the icon.
 * @param {function} props.onClick - Callback function for the button's click event.
 * @param {object} props.style - Style object to be applied to the button.
 * @param {string} props.className - Class name to be applied to the button, default is `lnk-color`, can set this according to buttons.scss.
 * @param {function} props.beforeInjection - Function to be applied to the SVG before it is injected into the DOM, this will override the default color, so use setSVGColor to set the color too.
 */
function SimpleIconButton({
    src,
    onClick,
    style,
    beforeInjection = setSVGColor("currentColor"),
    className = "lnk-color",
}) {
    return (
        <ReactSVG
            src={src}
            onClick={onClick}
            className={className}
            beforeInjection={beforeInjection}
            style={{ cursor: "pointer", ...style }}
        />
    );
}

export default SimpleIconButton;
